import ProductAddToCartHOC from '@common/components/ProductAddToCartHOC';
import ProductBundle from '@common/components/ProductBundle';
import ProductDetailsWrapper from '@common/containers/Wrapper/ProductDetailPage';
// import { PRODUCT_REFERRED_FROM } from '@common/models/Product';
// import { ReactComponent as NextArrow } from '@common/icons/NextArrow.svg';
import { RootState } from '@common/store';
import {
  addBundleProductToCartSuccess,
  addProductToCart,
  CartSliceType,
  subtractProductFromCart,
} from '@common/store/cart/slice';
import { CategoriesSliceType, fetchCategoriesRequest } from '@common/store/categories/slice';
import { FeaturesSliceType } from '@common/store/features/slice';
import {
  fetchProductBundleRequest,
  fetchProductDetailsRequest,
  fetchProductReviewsRequest,
  ProductDetailsSliceType,
} from '@common/store/productDetails/slice';
import { ProductsSliceType } from '@common/store/products/slice';
import { fetchProductsRequest } from '@common/store/products/slice';
import { RecentlyViewedSliceType } from '@common/store/recentlyViewed/slice';
import { StoreInfoSliceType } from '@common/store/storeInfo/slice';
import { addToast, removeToast, ToastWithKeyType } from '@common/store/toasts/slice';
// import { PRODUCTS_KEY } from '@common/utils/constants';
import Event from '@components/Event';
import PageLayout from '@components/PageLayout';
import Product from '@components/Product';
import Rating from '@components/Rating';
import RecentlyViewed from '@components/RecentlyViewed';
import Share from '@components/Share';
import { ReactComponent as BreadcrumbRightArrow } from '@images/downArrow.svg';
import Editor from '@lib/Editor';
import Link from '@lib/Link';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';

interface MatchParams {
  productId: string;
  productSlug: string;
}
interface ProductDetailState {
  selected: string;
}
interface ProductDetailProps extends RouteComponentProps<MatchParams> {
  cart: CartSliceType;
  toasts: ToastWithKeyType[];
  removeToast: typeof removeToast;
  productDetails: ProductDetailsSliceType;
  products: Record<string, ProductsSliceType>;
  recentlyViewed: RecentlyViewedSliceType;
  addToast: typeof addToast;
  addProductToCart: typeof addProductToCart;
  categories: CategoriesSliceType;
  fetchCategoriesRequest: typeof fetchCategoriesRequest;
  subtractProductFromCart: typeof subtractProductFromCart;
  fetchProductsRequest: typeof fetchProductsRequest;
  fetchProductDetailsRequest: typeof fetchProductDetailsRequest;
  fetchProductReviewsRequest: typeof fetchProductReviewsRequest;
  storeInfo: StoreInfoSliceType;
  features: FeaturesSliceType;
  addBundleProductToCartSuccess: typeof addBundleProductToCartSuccess;
  fetchProductBundleRequest: typeof fetchProductBundleRequest;
}

class ProductDetails extends React.Component<ProductDetailProps, ProductDetailState> {
  constructor(props) {
    super(props);

    this.state = {
      selected: 'description',
    };
  }

  setSelected(value) {
    this.setState({
      selected: value,
    });
  }

  render() {
    const { productDetails, addToast, addProductToCart, cart, features, addBundleProductToCartSuccess } = this.props;

    const product = productDetails.productDetails;
    const cartProductQuantity = cart.quantityByProductId[product?.id] || 0;
    // const featuredProductsExist = this.props.products[PRODUCTS_KEY.FEATURED]?.list?.results?.length;
    // const features = this.props?.features?.features || {};

    const scrollToReview = () => {
      if (this.state.selected !== 'review') this.setSelected('review');
    };
    return (
      <PageLayout hideToast>
        <ProductDetailsWrapper
          RecentlyViewed={RecentlyViewed}
          fetchCategoryReq={true}
          props={this.props}
          recentlyViewedClassnames={['w-full md:bg-header', 'container md:mx-auto mb-50 md:mb-70 md:pb-70', '']}
          showToast={true}
          mdpProductPage={true}
          mdpStorePage={true}
        >
          {!product?.isEvent ? (
            <ProductAddToCartHOC
              variantSetToMinQuantity={true}
              disableSuccessToasts={() => false}
              product={product}
              render={(hocArgs) => {
                const { finalProduct } = hocArgs;
                return (
                  <>
                    <div className="w-full ">
                      <div className="container md:mx-auto mb-12 md:mb-10 flex items-center py-8">
                        <div className="add-ellipsis text-khamaj-black" font-customisation="para-text">
                          <Link
                            to="/"
                            className="mr-8 cursor-pointer text-khamaj-promo"
                            color-customisation="page-body-text"
                          >
                            Home
                          </Link>
                          <BreadcrumbRightArrow className="mr-8 transform h-8 w-8 -rotate-90 inline-block" />
                          <span className="font-bold" color-customisation="page-body-text">
                            {product?.title ?? ''}
                          </span>
                        </div>
                        {/* {nextAndPrevious} */}
                      </div>
                    </div>
                    <div className="container md:mx-auto flex flex-wrap md:flex-no-wrap mb-5">
                      {productDetails.isFetched ? (
                        <Product
                          subtractProductFromCart={this.props.subtractProductFromCart}
                          product={product}
                          addProductToCart={addProductToCart}
                          addToast={addToast}
                          cartProductQuantity={cartProductQuantity}
                          isZoomEnabled={false}
                          storeType={this.props.storeInfo.storeInfo?.storeType}
                          review={this.props.productDetails?.reviews?.length}
                          reviewsCount={this.props.productDetails?.reviewsCount}
                          scrollToReview={scrollToReview}
                          toasts={this.props.toasts}
                          wishListFeature={features?.features?.wishList}
                          finalProduct={finalProduct}
                          hocArgs={hocArgs}
                          productVideoFeature={features?.features?.productVideo}
                        />
                      ) : null}
                    </div>
                    <div className="mt-30 md:mt-40 container md:mx-auto cursor-pointer hidden md:flex">
                      <div className="flex w-full  border-b border-khamaj-btnBorder max-h-42 md:max-h-46">
                        <div
                          className={classnames(
                            'playfair-bold md:font-normal text-khamaj-black text-16 md:text-21 leading-20 md:leading-25 pb-20 md:mr-20 min-h-44 md:min-h-47 min-w-110 md:min-w-140',
                            {
                              'border-khamaj-discount border-b-4': this.state.selected === 'description',
                            },
                          )}
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.selected !== 'description') this.setSelected('description');
                          }}
                          font-customisation="section-heading"
                          color-customisation="page-heading"
                        >
                          Description
                        </div>
                        <div
                          id="product-reviews-section-select"
                          className={classnames(
                            'playfair-bold md:font-normal text-khamaj-black text-16 md:text-21 leading-20 md:leading-25 pb-20 min-w-110 min-h-44 md:min-h-47 md:min-w-140',
                            {
                              'border-khamaj-discount border-b-4': this.state.selected === 'review',
                            },
                          )}
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.selected !== 'review') this.setSelected('review');
                          }}
                          font-customisation="section-heading"
                          color-customisation="page-heading"
                        >
                          Rating & Reviews({productDetails.reviewsCount})
                        </div>
                      </div>
                    </div>
                    <div className="hidden md:flex">
                      <>
                        {this.state.selected === 'description' ? (
                          <>
                            {product.description ? (
                              <div className="description container md:mx-auto mt-10">
                                <Editor
                                  name="productLongDescription"
                                  value={finalProduct.description}
                                  readonly={true}
                                />
                              </div>
                            ) : null}
                          </>
                        ) : (
                          this.state.selected === 'review' && (
                            <div id="product-reviews" className={classnames('container md:mx-auto mt-20')}>
                              <Rating
                                productSlug={product?.slug}
                                isNextReviewsLoading={productDetails.isNextReviewsLoading}
                                isNextReviewsLoadingFailed={productDetails.isNextReviewsLoadingFailed}
                                nextReviewsUrl={productDetails?.nextReviewsUrl}
                                reviewsCount={productDetails?.reviewsCount}
                                reviews={productDetails.reviews}
                                productId={product?.id}
                                rating={productDetails?.productDetails?.averageRating}
                              />
                            </div>
                          )
                        )}
                      </>
                    </div>
                    <div className="mt-40  container md:mx-auto mb-30 md:hidden">
                      <div
                        className="text-khamaj-black text-21 md:text-25 capitalize leading-25  mb-20  playfair-normal"
                        font-customisation="section-heading"
                        color-customisation="page-heading"
                      >
                        Product Description
                      </div>
                      {product.description ? (
                        <div className="description px-0">
                          <Editor
                            name="productLongDescription"
                            value={finalProduct.description}
                            readonly={true}
                            isDefaultFont={true}
                          />
                        </div>
                      ) : null}
                    </div>
                    <div className="container md:mx-auto px-20 md:px-112">
                      <div className="h-118 md:h-54 bg-header rounded-5 md:rounded-none items-center flex w-full justify-center mt-26 md:mt-40 mb-40 md:mb-54 p-20 md:p-0">
                        <Share className="w-full" product={product} />
                      </div>
                    </div>
                    {productDetails.bundle && (
                      <div className="bg-productBundle-extraLightGray py-70" color-customisation="page-bg">
                        <div className="container mx-auto">
                          <ProductBundle
                            productsBundle={productDetails.bundle}
                            productId={product?.id}
                            addToBundleProductInCart={addBundleProductToCartSuccess}
                            priceClassName={'text-black'}
                            discountPercentageColor={'bg-khamaj-discount'}
                            className={'bg-khamaj-discount text-white ripple rounded-full'}
                          />
                        </div>
                      </div>
                    )}
                    <div
                      id="product-reviews"
                      className="mt-40 md:mt-100 container md:mx-auto mb-50 md:mb-100 md:hidden"
                    >
                      <>
                        <div
                          className="w-full mb-24 flex text-khamaj-black capitalize playfair-normal text-21 leading-25"
                          font-customisation="section-heading"
                          color-customisation="page-heading"
                        >
                          Ratings & Reviews
                        </div>
                        <div className={classnames('md:mt-46')}>
                          <Rating
                            productSlug={product?.slug}
                            isNextReviewsLoading={productDetails.isNextReviewsLoading}
                            isNextReviewsLoadingFailed={productDetails.isNextReviewsLoadingFailed}
                            nextReviewsUrl={productDetails?.nextReviewsUrl}
                            reviewsCount={productDetails?.reviewsCount}
                            reviews={productDetails.reviews}
                            productId={product?.id}
                            rating={productDetails?.productDetails?.averageRating}
                          />
                        </div>
                      </>
                    </div>
                  </>
                );
              }}
            />
          ) : (
            <ProductAddToCartHOC
              variantSetToMinQuantity={true}
              disableSuccessToasts={() => false}
              product={product}
              render={(hocArgs) => {
                const { finalProduct } = hocArgs;
                return (
                  <>
                    <div className="w-full ">
                      <div
                        className="container md:mx-auto mb-12 md:mb-10 flex items-center text-khamaj-grey py-8"
                        font-customisation="para-text"
                      >
                        <div className="flex items-center text-12 md:text-14 font-normal">
                          <Link to="/" className="mr-8 cursor-pointer" color-customisation="page-body-text">
                            Home
                          </Link>
                          <BreadcrumbRightArrow className="mr-8 transform h-8 w-8 -rotate-90" />
                          <div className="font-semibold text-khamaj-black" color-customisation="page-body-text">
                            {product?.title ?? ''}
                          </div>
                        </div>
                        {/* {nextAndPrevious} */}
                      </div>
                    </div>
                    <div className="container md:mx-auto flex flex-wrap md:flex-no-wrap mb-5">
                      {productDetails.isFetched ? (
                        <Event
                          subtractProductFromCart={this.props.subtractProductFromCart}
                          product={product}
                          addProductToCart={addProductToCart}
                          addToast={addToast}
                          cartProductQuantity={cartProductQuantity}
                          storeType={this.props.storeInfo.storeInfo?.storeType}
                          review={this.props.productDetails?.reviews?.length}
                          scrollToReview={scrollToReview}
                          wishListFeature={features?.features?.wishList}
                          finalProduct={finalProduct}
                          hocArgs={hocArgs}
                          productVideoFeature={features?.features?.productVideo}
                        />
                      ) : null}
                    </div>

                    <div className="mt-30 md:mt-40 container md:mx-auto cursor-pointer hidden md:flex">
                      <div className="flex w-full  border-b border-khamaj-btnBorder max-h-42 md:max-h-46">
                        <div
                          className={classnames(
                            'playfair-bold md:font-normal text-khamaj-black text-16 md:text-21 leading-20 md:leading-25 pb-20 md:mr-20 min-h-44 md:min-h-47 min-w-110 md:min-w-140',
                            {
                              'border-khamaj-discount border-b-4': this.state.selected === 'description',
                            },
                          )}
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.selected !== 'description') this.setSelected('description');
                          }}
                          font-customisation="section-heading"
                          color-customisation="page-heading"
                        >
                          Description
                        </div>
                        <div
                          id="product-reviews-section-select"
                          className={classnames(
                            'playfair-bold md:font-normal text-khamaj-black text-16 md:text-21 leading-20 md:leading-25 pb-20 min-w-110 min-h-44 md:min-h-47 md:min-w-140',
                            {
                              'border-khamaj-discount border-b-4': this.state.selected === 'review',
                            },
                          )}
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.selected !== 'review') this.setSelected('review');
                          }}
                          font-customisation="section-heading"
                          color-customisation="page-heading"
                        >
                          Rating & Reviews({productDetails.reviewsCount})
                        </div>
                      </div>
                    </div>
                    <div className="hidden md:flex">
                      <>
                        {this.state.selected === 'description' ? (
                          <>
                            {product.description ? (
                              <div className="description container md:mx-auto mt-10">
                                <Editor
                                  name="productLongDescription"
                                  value={finalProduct.description}
                                  readonly={true}
                                />
                              </div>
                            ) : null}
                          </>
                        ) : (
                          this.state.selected === 'review' && (
                            <div id="product-reviews" className={classnames('container md:mx-auto mt-20')}>
                              <Rating
                                productSlug={product?.slug}
                                isNextReviewsLoading={productDetails.isNextReviewsLoading}
                                isNextReviewsLoadingFailed={productDetails.isNextReviewsLoadingFailed}
                                nextReviewsUrl={productDetails?.nextReviewsUrl}
                                reviewsCount={productDetails?.reviewsCount}
                                reviews={productDetails.reviews}
                                productId={product?.id}
                                rating={productDetails?.productDetails?.averageRating}
                              />
                            </div>
                          )
                        )}
                      </>
                    </div>
                    <div className="mt-40  container md:mx-auto mb-30 md:hidden">
                      <div
                        className="text-khamaj-black text-21 md:text-25 capitalize leading-25  mb-20  playfair-normal"
                        font-customisation="section-heading"
                        color-customisation="page-heading"
                      >
                        Event Description
                      </div>
                      {product.description ? (
                        <div className="description px-0">
                          <Editor
                            name="productLongDescription"
                            value={finalProduct.description}
                            readonly={true}
                            isDefaultFont={true}
                          />
                        </div>
                      ) : null}
                    </div>
                    <div className="container md:mx-auto px-20 md:px-112">
                      <div className="h-118 md:h-54 bg-header rounded-5 md:rounded-none items-center flex w-full justify-center mt-26 md:mt-40 mb-40 md:mb-54 p-20 md:p-0">
                        <Share className="w-full" product={product} />
                      </div>
                    </div>

                    {productDetails.bundle && (
                      <div className="bg-productBundle-extraLightGray py-70" color-customisation="page-bg">
                        <div className="container mx-auto">
                          <ProductBundle
                            productsBundle={productDetails.bundle}
                            productId={product?.id}
                            addToBundleProductInCart={addBundleProductToCartSuccess}
                            priceClassName={'text-black'}
                            discountPercentageColor={'bg-khamaj-discount'}
                            className={'bg-khamaj-discount text-white ripple rounded-full'}
                          />
                        </div>
                      </div>
                    )}
                    <div
                      id="product-reviews"
                      className="mt-40 md:mt-100 container md:mx-auto mb-50 md:mb-100 md:hidden"
                    >
                      <>
                        <div
                          className="w-full mb-24 flex text-khamaj-black capitalize playfair-normal text-21 leading-25"
                          font-customisation="section-heading"
                          color-customisation="page-heading"
                        >
                          Ratings & Reviews
                        </div>
                        <div className={classnames('md:mt-46')}>
                          <Rating
                            productSlug={product?.slug}
                            isNextReviewsLoading={productDetails.isNextReviewsLoading}
                            isNextReviewsLoadingFailed={productDetails.isNextReviewsLoadingFailed}
                            nextReviewsUrl={productDetails?.nextReviewsUrl}
                            reviewsCount={productDetails?.reviewsCount}
                            reviews={productDetails.reviews}
                            productId={product?.id}
                            rating={productDetails?.productDetails?.averageRating}
                          />
                        </div>
                      </>
                    </div>
                  </>
                );
              }}
            />
          )}
        </ProductDetailsWrapper>
      </PageLayout>
    );
  }
}

export default connect(
  ({ cart, productDetails, products, toasts, categories, recentlyViewed, storeInfo, features }: RootState) => ({
    storeInfo,
    toasts,
    cart,
    products,
    categories,
    productDetails,
    recentlyViewed,
    features,
  }),
  {
    fetchProductsRequest,
    fetchProductDetailsRequest,
    fetchCategoriesRequest,
    fetchProductReviewsRequest,
    addToast,
    removeToast,
    addProductToCart,
    subtractProductFromCart,
    fetchProductBundleRequest,
    addBundleProductToCartSuccess,
  },
)(ProductDetails);
